import DropdownFilter from 'components/dropdownFilters/DropdownFilter';
import template from 'templates/filters/__profiles.tpl';

export class ProfileDropdown extends DropdownFilter {
    constructor(options = {}, data) {
        super(options);
        this.data = data;
    }

    __render() {
        if (this.options.length > 0 && this.selectedInd < this.options.length) {
            this._.append(
                $(
                    template({
                        data: this.options,
                        selected: this.options[this.selectedInd],
                    }),
                ),
            );
        }
    }

    __isSwitchingToLockedProfile(selectedProfileId) {
        return (
            this.data?.profiles?.some(
                (profile) => profile.id === selectedProfileId && profile.isLocked,
            ) || false
        );
    }

    __selectedHandler(e) {
        const target = e.target;
        const selectedIndex = target.getAttribute('data-index');
        if (selectedIndex) {
            let evt = new Event('profileAction');
            if (this.options[selectedIndex].value === -2) {
                evt.action = 'NewKidsProfile';
            } else if (this.options[selectedIndex].value === -3) {
                evt.action = 'NewProfile';
            } else {
                evt.action = 'SwitchProfile';
                evt.profile = this.options[selectedIndex];
                evt.isSwitchingToLockedProfile = this.__isSwitchingToLockedProfile(
                    this.options[selectedIndex]?.id,
                );
            }
            evt.carouselTitle = this._.parent()
                .find('.video-section-title')
                .text()
                .trimStart()
                .trimEnd();
            window.dispatchEvent(evt);
        }
    }
}
